var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isGranted('ROLE_COMPANY_SHOW'))?_c('router-link',{attrs:{"to":{name: 'CompanyShow', params: { id: _vm.data['@id'] }}}},[_vm._v("\n    "+_vm._s(_vm.data.code)+"\n  ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }